<div class="k-loading-panel" *ngIf="spin">
    <div class="k-loading-panel-mask"></div>
    <div class="k-loading-panel-wrapper">
      <kendo-loader type="converging-spinner"></kendo-loader>

      <div class="k-loading-panel-text">Loading...</div>
    </div>
  </div>
<router-outlet></router-outlet>
